import {Component} from 'san';

import loadScript from '@/lib/utils/loadScript';
import styles from './style/index.module.less';

export default class Report extends Component {
    static template = require('./index.html');
    initData() {
        return {
            styles
        };
    }
    setReport() {
        if (window.bds && window.bds.qa && window.bds.qa.ShortCut) {
            this.initReport();
        }
        else {
            loadScript(
                'https://ufosdk.baidu.com/Public/feedback/js/dist/feedback_plugin_2.0.js',
                () => {
                    this.initReport();
                },
                {
                    charset: 'utf-8',
                    id: 'feedback_script'
                }
            );
        }
    }
    initReport() {
        const isLogin = this.data.get('common.isLogin');
        if (!isLogin) {
            const currentHref = window.location.href;
            window.location.href = 'https://passport.baidu.com/v2/?login&tpl=mn&u=' + encodeURIComponent(currentHref);
            return;
        }
        /* eslint-disable no-undef */
        if (bds && bds.qa && bds.qa.ShortCut && bds.qa.ShortCut.initRightBar) {
            let fb_options = {
                needImage: true,
                appid: 215939,
                productLine: 90509,
                'upload_file': true,
                requiredContent: false,
                issuePlaceholder: '请输入问题描述',
                contactPlaceholder: '请填写联系方式',
                isReport: true,
                hideHotQuestion: true
            };
            bds.qa.ShortCut.initRightBar(fb_options);
            let proData = {
                'referer': window.location.href,
                'extend_url': window.location.href,
                'extend_feedback_channel': '32598',
                'resource_id': this.data.get('common.nid') || '',
                'daily_type': '67752',
                'remark': 'bjh'
            };
            bds.qa.ShortCut._getProData(proData);
        }
        /* eslint-enable no-undef */
    }
};